// Constantes utilizadas no módulo Register

// Tipos de pragas que usam o componente CaterpillarPlague
export const CATERPILLAR_PLAGUES = [
  "Lagarta Parda",
  "Lagarta Verde",
  "Lagarta Cachorrinho",
  "Lagarta Marrom",
  "Glena",
  "Sarsina",
  "Dyrphia",
  "Nistalea",
  "Hylesia",
  "Sabulodes"
];

// Tipos de pragas que usam o componente BeetlePlague
export const BEETLE_PLAGUES = [
  "Besouro Amarelo",
  "Besouro Azul"
];

// Tipos de pragas que usam o componente PsilideoPlague
export const PSILIDEO_PLAGUES = [
  "Psilideo de Concha",
  "Percevejo Bronzeado"
];

export const LEPTOCYBE_PLAGUES = ["Vespa-da-galha"];

/** Pragas disponíveis no registro BRACELL (paridade SF-APP). */
export const BRACELL_REGISTER_PLAGUE_NAMES = [
  ...CATERPILLAR_PLAGUES,
  ...BEETLE_PLAGUES,
  ...PSILIDEO_PLAGUES,
  ...LEPTOCYBE_PLAGUES,
];

// Mensagens
export const MESSAGES = {
  REGISTER_SUCCESS: "Registro cadastrado com sucesso!",
  REGISTER_ERROR: "Erro ao realizar o registro, verifique as informações novamente",
  REGISTER_OFFLINE_SUCCESS: "Registro salvo para envio quando voltar online",
  PLOTS_LOAD_ERROR: "Erro ao carregar plots",
  PLOT_NOT_FOUND: "Talhão não encontrado"
};

// Chaves do localStorage
export const STORAGE_KEYS = {
  ALL_PLOTS: "allPlots",
  REGISTER_PLOT_ALTERNATE: "register-plot-alternate",
  REGISTERS_TO_INVITE: "registers-to-invite"
};

